import logger from 'shared/services/logger'
import LastActivityContainer from 'views/containers/browser/LastActivityContainer'
import hydrateWithHOCs from 'views/containers/browser/utils/hydrateWithHOCs'

export default ({ container, i18n }) => {
  logger.info('LastActivity module loaded')

  hydrateWithHOCs({
    container,
    i18n,
  })(<LastActivityContainer />)
}
